import React, { useState } from "react";
import "./OverseasEducation.css";
import { AiOutlineGlobal } from "react-icons/ai";   // for "Recognized globally"
import { AiOutlineUser } from "react-icons/ai";     // for "Face-to-face speaking"
import { AiOutlineCalendar } from "react-icons/ai"; // for "Multiple test dates"
import ieltsImg from "../../Assets/TEST-PRE/IELTS-Exam.jpg";
import { FaLaptopCode, FaUniversity } from "react-icons/fa";
import toeflImg from '../../Assets/TEST-PRE/TOEFL-Exam.jpg'
import pteImg from '../../Assets/TEST-PRE/PTE-Exam.jpg'

const EnglishTests = () => {
  const [activeTest, setActiveTest] = useState("IELTS");

  return (
    <section className="english-tests-section container">
      <h2 className="heading text-center mb-5">
        Essential English Tests for <br /> Overseas Education
      </h2>

      <div className="filter-buttons">
        <button
          className={`filter-btn ${activeTest === "IELTS" ? "active" : ""}`}
          onClick={() => setActiveTest("IELTS")}
        >
          IELTS
        </button>
        <button
          className={`filter-btn ${activeTest === "TOEFL" ? "active" : ""}`}
          onClick={() => setActiveTest("TOEFL")}
        >
          TOEFL
        </button>
        <button
          className={`filter-btn ${activeTest === "PTE" ? "active" : ""}`}
          onClick={() => setActiveTest("PTE")}
        >
          PTE
        </button>
      </div>

     {activeTest === "IELTS" && (
      <div>

<div className="test-content">
    <img src={ieltsImg} alt="IELTS" className="test-image" />
    <div className="test-text">
      <h3 className="test-title">
        IELTS – The International English Language Testing System
      </h3>
      <p className="test-desc">
        The IELTS is one of the most widely recognized English proficiency tests in the world.
        It is accepted by universities, employers, and immigration authorities in countries
        like the UK, Australia, Canada, New Zealand, and more.
      </p>
    </div>
  </div>
        <div className="why-choose-ielts mt-5">
        <h4 className="related-title text-center">RELATED COURSES</h4>
        <h2 className="why-title text-center mb-4 text-muted">Why Choose IELTS?</h2>

        <div className="why-cards d-flex justify-content-center gap-4 flex-wrap">
          <div className="why-card">
             <AiOutlineGlobal className="icon" />
            <p className="text-muted">Recognized globally for admissions and work visa applications.</p>
          </div>
          <div className="why-card">
            <AiOutlineUser className="icon" />
            <p className="text-muted">Face-to-face speaking test with an examiner.</p>
          </div>
          <div className="why-card">
            <AiOutlineCalendar className="icon" />
            <p className="text-muted">Multiple test dates available throughout the year.</p>
          </div>
        </div>

        <p className="why-desc text-center mt-4 text-muted">
          At Nova EduBridge, we help you prepare for the IELTS with practice sessions, mock tests,
          and expert feedback, so you can achieve the score required for your chosen destination.
        </p>
      </div>
      </div>
  
  
)}


      {activeTest === "TOEFL" && (
         <div>

<div className="test-content">
    <img src={toeflImg} alt="IELTS" className="test-image" />
    <div className="test-text">
      <h3 className="test-title">
        TOEFL – Test of English as a Foreign Language
      </h3>
      <p className="test-desc">
     The TOEFL is especially popular among students applying to universities in the United States, Canada, and other English-speaking countries. It is designed to measure how well you can use and understand English in an academic setting.
     <ul className="mt-3">
      <li className="mb-2"><b>Test Format:</b> TOEFL iBT (Internet-Based Test) is the most common, but a paper-based version is available in some regions.</li>
      <li className="mb-2"><b>Skills Tested:</b> Reading, Listening, Speaking, and Writing.</li>
      <li className="mb-2"><b>Scoring:</b> Each section is scored out of 30, for a total score of 120.</li>
     </ul>
      </p>
    </div>
  </div>
        <div className="why-choose-ielts mt-5">
        <h4 className="related-title text-center">RELATED COURSES</h4>
        <h2 className="why-title text-center mb-4">Why Choose TOEFL?</h2>

       <div className="why-cards d-flex justify-content-center gap-4 flex-wrap">
  <div className="why-card">
    <FaUniversity className="icon" />
    <p>Preferred by thousands of universities, especially in North America.</p>
  </div>
  <div className="why-card">
    <FaLaptopCode className="icon" />
    <p>The entire test is computer-based, including the speaking section.</p>
  </div>
  <div className="why-card">
    <AiOutlineCalendar className="icon" />
    <p>Flexible scheduling with test centers worldwide.</p>
  </div>
</div>


        <p className="why-desc text-center mt-4">
        Nova EduBridge provides structured TOEFL training that focuses on academic vocabulary, note-taking, time management, and building the skills needed to score high in each section.
        </p>
      </div>
      </div>
      )}

      {activeTest === "PTE" && (
        <div>

<div className="test-content">
    <img src={pteImg} alt="IELTS" className="test-image" />
    <div className="test-text">
      <h3 className="test-title">
        PTE – Pearson Test of English
      </h3>
      <p className="test-desc">
"The PTE exam for international students is a computer-based English test that uses AI scoring technology, ensuring unbiased evaluation and quick results. It is widely accepted by universities, colleges, and governments for study, work, and migration purposes in countries like Australia, New Zealand, the UK, Canada, and more."
     <ul className="mt-3">
      <li className="mb-2"><b>Test Format:</b> Fully computer-based, including speaking and writing.</li>
      <li className="mb-2"><b>Skills Tested:</b> Speaking & Writing, Reading, and Listening.</li>
      <li className="mb-2"><b>Scoring:</b> Scored on a scale of 10–90.</li>
     </ul>
      </p>
    </div>
  </div>
        <div className="why-choose-ielts mt-5">
        <h4 className="related-title text-center">RELATED COURSES</h4>
        <h2 className="why-title text-center mb-4">Why choose PTE??</h2>

       <div className="why-cards d-flex justify-content-center gap-4 flex-wrap">
  <div className="why-card">
    <FaUniversity className="icon" />
    <p>Fast results – usually within 48 hours.</p>
  </div>
  <div className="why-card">
    <FaLaptopCode className="icon" />
    <p>Flexible test booking and multiple test dates.</p>
  </div>
  <div className="why-card">
    <AiOutlineCalendar className="icon" />
    <p>AI-powered scoring ensures consistency.</p>
  </div>
</div>


        <p className="why-desc text-center mt-4">
       With Nova EduBridge’s PTE preparation programs, you’ll practice with official materials, learn proven strategies, and take mock exams that mirror the actual test environment.
        </p>
      </div>
      </div>
      )}
    </section>
  );
};

export default EnglishTests;
